import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/headerfunc'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import HomeLogged from '../../../components/funcionarios/home'

function HomeLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Holerites | Funcionários" />
                <HeaderLogged />
                <Container>
                   <HomeLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default HomeLoggedScreen;